import { useEffect, useState } from "react";
import { Control } from "react-hook-form";
import { Box, Button, DialogContent, Stack, Typography } from "@mui/material";

import { FormInputValidationNumber } from "../../../signup/components/forminputinvalidationnumber";

import { useFormatter } from "../../../../utils/useFormatter";
import { FormButtonGroup } from "../../../../components/form";

interface IFormInput {
  phone: string;
  confirmationCode: string;
}

interface IProps {
  control: Control<IFormInput | any>;
  loading: boolean;
  phone: string;
  onGoBackButtonClick: Function;
  onResendButtonClick: Function;
  onSubmitButtonClick: Function;
}

const SEND_CODE_TIMER = 10;

export default function ConfirmPhoneContent({
  onGoBackButtonClick,
  onResendButtonClick,
  onSubmitButtonClick,
  control,
  loading,
  phone,
}: IProps) {
  const { formatPhoneNumber } = useFormatter;

  const [counter, setCounter] = useState(SEND_CODE_TIMER);

  const IS_BUTTON_DISABLED = counter !== 0;

  useEffect(() => {
    const interval = setInterval(() => {
      if (counter > 0) {
        setCounter((prevCounter) => prevCounter - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [counter]);

  return (
    <DialogContent>
      <Stack spacing={2} alignItems="center">
        <Typography
          textAlign="center"
          color="neutral600.main"
          variant="body1"
          sx={{ px: 4 }}
        >
          Finalize a edição do seu telefone inserindo o código enviado para{" "}
          <strong>{formatPhoneNumber(phone)}</strong>
        </Typography>
        <FormInputValidationNumber
          name="confirmationCode"
          control={control}
          label=""
          pattern={[1 - 9]}
          autoFocus
        />
        <Box display="flex" flexDirection="row" gap={2}>
          <Button
            disabled={IS_BUTTON_DISABLED}
            variant="text"
            sx={{ color: "neutral1000.main", textTransform: "none" }}
            onClick={() => {
              onResendButtonClick();
              setCounter(SEND_CODE_TIMER);
            }}
            id="recaptcha-button"
          >
            {IS_BUTTON_DISABLED
              ? `Você pode reenviar o código em ${counter}`
              : "Reenviar código"}
          </Button>
        </Box>
      </Stack>
      <Stack
        minWidth="100%"
        mt={3}
        direction="row"
        justifyContent="space-between"
        spacing={2}
      >
        <FormButtonGroup
          onGoBackButtonClick={() => onGoBackButtonClick()}
          onNextButtonClick={() => onSubmitButtonClick()}
          goBackButtonText="Voltar"
          nextButtonText="Salvar"
          loading={loading}
        />
      </Stack>
    </DialogContent>
  );
}
